const ALLOWED_PROTOCOLS = ['https:', 'http:'];

export function safeHref(url) {
	if (!url) return null;
	try {
		const parsed = new URL(url);
		if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) return null;
		return encodeURI(`${parsed.protocol}//${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`);
	} catch {
		return null;
	}
}
